import Backbone from 'backbone'
import template from './home-nav.hbs'
import permissions from 'scoreboard/components/permissions'
import alerts from 'scoreboard/components/alerts'
import _ from 'lodash'
import license from 'scoreboard/components/license'
import user from 'scoreboard/components/user'
import config from 'scoreboard/components/config'
import pendingMetricValueApprovals from './metric-approvals/pending-metric-value-approvals'
import showAlertBubble from 'scoreboard/alerts/show-alert-bubble'
import { isV5, isV6 } from 'scoreboard/components/version'

var Nav = Backbone.View.extend({

	section: 'home',

	initialize: function(options) {
		this.options = options
		this.listenTo(Backbone, 'change:unread', ({numUnread}) =>
			showAlertBubble(this, '.alerts', numUnread))
		this.listenTo(Backbone, 'change:numPending', ({numPending}) =>
			showAlertBubble(this, '.pending', numPending))
		this.listenTo(Backbone, 'decrement:unread', () =>
			showAlertBubble(this, '.alerts', alerts.unreadAlerts - 1))
	},

	render: function() {
		this.$el.empty().append(template())
		if (isV5()) {
			this.$el.addClass('home-nav')
		}
		if (isV6()) {
			this.$(`.${this.options.section} .sp-navigate`).addClass('current')
		}
		showAlertBubble(this, '.alerts', alerts.unreadAlerts)
		showAlertBubble(this, '.pending', pendingMetricValueApprovals.numPending)

		this.secure()
		return this
	},

	secure: function() {
		if (permissions.readOnly()) {
			this.$('.metric-updates, .my-tasks').remove()
			// #32726 gives interactive users the ability to be owners. Want to
			// enable navigation to the 'my metrics pane'
			if (!permissions.activeViewer()) {
				this.$('.my-metrics, .metric-approvals').remove()
			}
		}
		if (!config.kpiValuesRequireApproval) {
			this.$('.metric-approvals').remove()
		}
		if (!license.scorecards) {
			this.$('.my-metrics').remove()
		}
		if (!license.initiatives) {
			this.$('.my-tasks').remove()
		}
		if (user.model.get('publicReadOnlyUser')) {
			this.$('.alert-bubble.alerts').remove()
			this.$('.alert-bubble.pending').remove()
		}
	},

	// this is called in the router
	select: function(item) {
		this.$('li').removeClass('is-selected')
		this.$('.' + item).addClass('is-selected')
	},

	// this is kind of a hack, but when viewing a bookmark of something like
	// a dashboard, the overview route expects this method to be here
	toggleEdit: _.identity

})

export default Nav

Nav.__filename__ = 'home/home-nav.js'
